export default function getDataUrlImageType(dataUrl: string): string | null {
  const m = dataUrl.match(/^data:image\/([a-z0-9+]+)(?=;|,)/i);
  if (!m) return null;
  const fmt = m[1].toLowerCase();
  switch (fmt) {
    case "jpeg":
      return "JPEG";
    case "jpg":
      return "JPG";
    case "png":
      return "PNG";
    case "heic":
      return "HEIC";
    default:
      return null;
  }
}
